<template>
    <applyModal :modalTitle="'道路测试延期申请'" :isDetailStatus="false" ref="modalDetailRef" @cancelEvent="handleClose">
        <div class="mt20 mb62">
            <div class="mt16 mb20">
                延期日期: <a-date-picker v-model:value="delayDate" :disabled-date="disabledDate" format="YYYY-MM-DD"
                    valueFormat="YYYY-MM-DD" @change="dateChange" style="width: 83%;margin-left:20px" />
            </div>
            <div class="modal_content">
                <div class="file_text">
                    道路测试延期申请表
                </div>
                <div class="into">下载模板，根据模板提示完善内容</div>
                <div class="update_btn">
                    <div @click="downloadAll"><i class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>下载模板</div>
                </div>
            </div>
            <div class="mt16">
                <upload ref="uploadRef" @uploadFinished="uploadFinished" />
            </div>
            <div class="mt16 list">

                <div class="modal_table">
                    <div class="info">历史申请记录</div>
                    <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" size="middle"
                        :pagination="false" :scroll="{ y: 140 }">
                        <template #bodyCell="{ column, record }">

                            <template v-if="column.key === 'checkTime' && record.checkTime">
                                {{ dayjs(record.checkTime).format("YYYY-MM-DD HH:mm:ss") }}
                            </template>
                            <template v-if="column.key === 'info'">
                                {{ getResult(record) }}
                            </template>
                            <template v-else-if="column.key === 'action'">
                                <span v-if="record.uploadFile">
                                    <a :href="record.uploadFile" target="_blank" class="alink">{{ getFileName(record)
                                        }}</a>
                                </span>
                            </template>
                        </template>
                    </a-table>
                </div>

            </div>

            <div class="mt16 botmBtn">
                <a-button type="primary" ghost class="mr10" @click="cancel">取消</a-button>
                <a-button type="primary" class="ml10" @click="confirm">确定</a-button>
            </div>
        </div>
    </applyModal>
</template>

<script setup>
import { ref, onMounted, reactive, watch, nextTick, defineExpose, defineProps, defineEmits } from "vue";
import applyModal from '@/components/modal/index.vue'
import { Modal, message } from 'ant-design-vue'
import upload from '@/components/uploadProgress/index.vue'
import moment from "moment";
import dayjs from 'dayjs';
import { getListByCondition, checkQualificationDate, getDelayRecordsByQualificationId, qualificationDelayApply } from '@/api/qualification/index'

const props = defineProps({
    //资质id,单个更新材料时使用
    id: {
        type: String,
        default: () => "",
    },
    testEndTime: {
        type: String,
        default: () => "",
    }
});

const emits = defineEmits(['applyFinished'])

const modalDetailRef = ref()
const show = (record) => {
    delayDate.value = null
    console.log(record);
    getTable()
    getTempFile();
    modalDetailRef.value.showModal()

}


const columns = [
    {
        title: "申请时间",
        dataIndex: "createTime",
        key: "createTime",
    },
    {
        title: "延期时间",
        dataIndex: "delayTime",
        key: "delayTime",
    },
    {
        title: "审批时间",
        dataIndex: "checkTime",
        key: "checkTime",
    },
    {
        title: "审核结果",
        dataIndex: "info",
        key: "info",
    },
    {
        title: "操作",
        dataIndex: "action",
        key: "action",
    },
]

const fileList = ref([]);
function getTempFile() {
    getListByCondition({ funcCode: 'qualification_delay_apply' }).then(res => {
        fileList.value = res.data;
    })
}

function downloadAll() {
    fileList.value.forEach((item, index) => {
        setTimeout(() => {
            let a = document.createElement('a');
            console.log(item)
            a.href = item.url;
            a.target = '_blank';
            // a.download = `file`;
            // 触发 click 事件
            a.click();
        }, index * 1000);
    });
}

const dataSource = ref([]);
function getTable() {

    getDelayRecordsByQualificationId({ qualificationId: props.id }).then(res => {
        dataSource.value = res.data;
    })
}

function getResult(row) {
    let str = row.checkStatus == null || row.checkStatus == 0 ? "待审核" : row.checkStatus == 1 ? '审核通过' : "审核不通过";
    return str + (row.checkMsg ? row.checkMsg + '' : "");
}

const disabledDate = current => {
    return current && current < moment(props.testEndTime).endOf('day');
};

function getFileName(row) {
    let arr = row.uploadFile.split('/');
    return arr[arr.length - 1]
}

//下载信息变更表
function downloadFile(row) {
    console.log(row)
}

const delayDate = ref();
const dateChange = () => {
    console.log(delayDate.value)
    let obj = {
        id: props.id,
        delayDate: delayDate.value
    }
    checkQualificationDate(obj).then(res => {
        if (!res.data.result) {
            delayDate.value = null;
            message.error(res.data.msg);
        }
    })
}

const uploadFile = ref();
function uploadFinished(url) {
    uploadFile.value = url;
    console.log(url)
}

// 保存
const confirm = () => {
    console.log('保存');
    let obj = {
        "delayTime": delayDate.value,
        "status": 1,
        "materialTemplateId": 65,
        "qualificationId": props.id,
        "uploadFile": uploadFile.value
    }
    if (delayDate.value) {
        qualificationDelayApply(obj).then(res => {
            if (res.code == 200) {
                message.success("提交成功");
                modalDetailRef.value.hideModal()
                emits('applyFinished')
            }
        })
    }else{
        message.warning("请输入延期日期");
    }


}
// 取消
const cancel = () => {
    modalDetailRef.value.hideModal();
}

const uploadRef = ref();
function handleClose() {
    console.log(2222)
    uploadRef.value.reset();
}

defineExpose({
    show
})

onMounted(() => {
})
</script>

<style lang="less" scoped>
.mb62 {
    margin-bottom: 62px;
}

.modal_content {
    // width: 516px;
    height: 154px;
    background: rgba(246, 248, 250, 1);
    display: flex;
    flex-direction: column;
    align-items: center;

    .file_text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1D2129;
        padding-top: 24px;
    }

    .into {
        font-size: 14px;
        color: #636D7B;
        margin: 16px 0;
    }

    .update_btn {
        cursor: pointer;
        padding: 3px 0;
        width: 100px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #636D7B;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #636D7B;
        text-align: center;
    }
}

/deep/.list {
    .tit {
        font-size: 16px;
        color: #1D2129;
        margin: 28px 0 22px 0;
        font-weight: 400;
    }

    .info {
        color: #636D7B;
        font-size: 14px;
        margin-bottom: 17px;
    }

    .modal_table {
        background: #F6F8FA;
        border-radius: 4px 4px 4px 4px;
        padding: 10px 27px;
        font-size: 12px;

        th {
            background: #fff !important;
            text-align: center;
            font-size: 12px;
        }

        td {
            text-align: center;
            font-size: 12px;
        }

        .alink {
            color: #186FF2;
            font-size: 12px;
        }
    }
}

.botmBtn {
    display: flex;
    justify-content: center;

    .mr10 {
        margin-right: 5%;
        margin-left: 5%;
    }

    .ml10 {
        margin-left: 5%;
    }
}
</style>